//#region src/index.ts
const ARROW_EXP = "ArrowFunctionExpression";
const plugin = {
	name: "arrow",
	init(jsep) {
		jsep.addBinaryOp("=>", .1, true);
		jsep.hooks.add("gobble-expression", function gobbleEmptyArrowArg(env) {
			this.gobbleSpaces();
			if (this.code === jsep.OPAREN_CODE) {
				const backupIndex = this.index;
				this.index++;
				this.gobbleSpaces();
				if (this.code === jsep.CPAREN_CODE) {
					this.index++;
					const biop = this.gobbleBinaryOp();
					if (biop === "=>") {
						const body = this.gobbleBinaryExpression();
						if (!body) this.throwError("Expected expression after " + biop);
						env.node = {
							type: ARROW_EXP,
							params: null,
							body
						};
						return;
					}
				}
				this.index = backupIndex;
			}
		});
		jsep.hooks.add("after-expression", function fixBinaryArrow(env) {
			updateBinariesToArrows(env.node);
		});
		function updateBinariesToArrows(node) {
			if (node) {
				Object.values(node).forEach((val) => {
					if (val && typeof val === "object") updateBinariesToArrows(val);
				});
				const arrowNode = node;
				if (arrowNode.operator === "=>") {
					arrowNode.type = ARROW_EXP;
					arrowNode.params = arrowNode.left ? [arrowNode.left] : null;
					arrowNode.body = arrowNode.right;
					if (arrowNode.params && arrowNode.params[0].type === jsep.SEQUENCE_EXP) arrowNode.params = arrowNode.params[0].expressions;
					delete arrowNode.left;
					delete arrowNode.right;
					delete arrowNode.operator;
				}
			}
		}
	}
};
var src_default = plugin;

//#endregion
export { src_default as default };
//# sourceMappingURL=index.js.map